var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('barchart',{attrs:{"data":_vm.bars,"infosheet":""}}),_c('v-card-text',{staticClass:"caption py-1"},[_vm._v(_vm._s(_vm.description))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }